module.exports = __webpack_public_path__ + "img/link-outline.e56584d9.svg";